import React from 'react';
import { Helmet } from 'react-helmet';

const HubSpotHealthcareForm = () => {
  return (
    <Helmet>
      <script
        src="https://code.jquery.com/jquery-3.7.1.slim.min.js"
        integrity="sha256-kmHvs0B+OpCW5GVHUNjv9rOmY0IvSIRcf7zGUDTDQM8="
        crossorigin="anonymous"
      ></script>
      <script
        id='formScript24439000000300101'
        src='https://crm.zohocloud.ca/crm/WebFormServeServlet?rid=407b37bc2e7cf366f1b8ba845abd9ba7097764fcb7326948a2a24f1e2953216ed0f5bf0cbaa5adc3b1f3653f656c9edcgid4f321db5ca2256e05a04c1ac11468ba0fa59ac37437e862d2602c9b8b21148e9&script=$sYG'
      ></script>
    </Helmet>
  );
};

export default HubSpotHealthcareForm;
